import FiscalDocTypeCodeEnum from '@/api/Enums/FiscalDocTypeCodeEnum.js'
import FiscalDocTypeEnum from '@/api/Enums/FiscalDocTypeEnum.js'

export default {

  Language: {
    el: {
      id      : 12,
      active  : true,
      web     : true,
      pos     : true,
      name    : 'Ελληνικά',
      locale  : 'el',
      code    : 'el-GR',
      code2   : 'el_GR',
      imageUrl: 'https://cdn.getfood.pro/flags/1x1/el.svg'
    },
    en: {
      id      : 11,
      active  : true,
      web     : true,
      pos     : true,
      name    : 'Αγγλικά',
      locale  : 'en',
      code    : 'en-US',
      code2   : 'en_US',
      imageUrl: 'https://cdn.getfood.pro/flags/1x1/gb.svg'
    },
    bg: {
      id      : 13,
      active  : true,
      web     : false,
      pos     : false,
      name    : 'Βουλγάρικα',
      locale  : 'bg',
      code    : 'bg-BG',
      code2   : 'bg_BG',
      imageUrl: 'https://cdn.getfood.pro/flags/1x1/bg.svg'
    },
    fr: {
      id      : 14,
      active  : true,
      web     : false,
      pos     : false,
      name    : 'Γαλλικά',
      locale  : 'fr',
      code    : 'fr-FR',
      code2   : 'fr_FR',
      imageUrl: 'https://cdn.getfood.pro/flags/1x1/fr.svg'
    }
  },

  Date: {
    Title      : 'Ημερομηνία',
    DateShort  : 'Ημ/νία',
    Time       : 'Ώρα',
    Hour       : 'Ώρα',
    Minute     : 'Λεπτά | Λεπτό | Λεπτά',
    Today      : 'Σήμερα',
    Tomorrow   : 'Αύριο',
    Day        : 'Ημέρα',
    Week       : 'Εβδομάδα',
    Month      : 'Μήνας',
    ThreeMonths: 'Τρίμηνο',
    SixMonths  : 'Εξάμηνο',
    Year       : 'Έτος',
    Period     : 'Περίοδος',
    PeriodFrom : 'Από',
    PeriodTo   : 'Έως',
    WeekDays   : {
      Short: ['Δευ', 'Τρι', 'Τετ', 'Πεμ', 'Παρ', 'Σαβ', 'Κυρ'],
      Long : ['Δευτέρα', 'Τρίτη', 'Τετάρτη', 'Πέμπτη', 'Παρασκευή', 'Σάββατο', 'Κυριακή']
    },
    Now             : 'Τώρα',
    WithOpenHours   : 'Βάση Ωραρίου',
    WithoutOpenHours: 'Ημερολογιακά'
  },

  Update: {
    Cloud: {
      Title          : 'Nέα έκδοση διαθέσιμη',
      BodyWithVersion: 'Υπάρχει διαθέσιμη ενημέρωση του συστήματος. Πατήστε "ΕΝΗΜΕΡΩΣΗ ΤΩΡΑ" για να ολοκληρωθεί και να μεταβείτε από την έκδοση v{CurrentVersion} στην νέα έκδοση v{ServerVersion}.',
      BodyNoVersion  : 'Υπάρχει διαθέσιμη ενημέρωση του συστήματος. Πατήστε "ΕΝΗΜΕΡΩΣΗ ΤΩΡΑ" για να ολοκληρωθεί και να μεταβείτε στην νέα έκδοση.'
    }
  },

  Button: {
    All                      : 'Όλα',
    Select                   : 'Επιλογή',
    PaymentAll               : 'Πληρωμή Όλων',
    Notify                   : 'Ειδοποίηση',
    NotifyCollect            : 'Ειδοποίηση Παραλαβής',
    NotifyStatus             : 'Ειδοποίηση Κατάστασης',
    NotifyCustomer           : 'Ειδοποίηση Πελάτη',
    Transactions             : 'Συναλλαγές',
    PaymentWith              : 'Πληρωμή με',
    Backup                   : 'Backup',
    Upgrade                  : 'Αναβάθμιση',
    Downgrade                : 'Υποβάθμιση',
    ChangePlan               : 'Αλλαγή Πλάνου',
    ChangePayment            : 'Αλλαγή',
    RenewPlan                : 'Ανανέωση Συνδρομής',
    CurrentPlan              : 'Τρέχον Πλάνο',
    Retry                    : 'Retry',
    RetryOnce                : 'Retry Once',
    RetryAll                 : 'Retry All',
    More                     : 'Περισσότερα',
    Less                     : 'Λιγότερα',
    Save                     : 'Αποθήκευση',
    Cancel                   : 'Ακύρωση',
    CancelWithRefund         : 'Ακύρωση & Επιστροφή',
    Close                    : 'Κλείσιμο',
    Duplicate                : 'Αντιγραφή',
    Delete                   : 'Διαγραφή',
    Update                   : 'Ενημέρωση',
    History                  : 'Ιστορικό',
    ReportHistory            : 'Ιστορικό Αναφορών',
    Send                     : 'Αποστολή',
    EmailSend                : 'Αποστολή με Email',
    EmailSendPdf             : 'Αποστολή PDF με Email',
    EmailSendExcel           : 'Αποστολή Excel με Email',
    MessageSend              : 'Αποστολή με Μήνυμα',
    Here                     : 'Εδώ',
    Translate                : 'Μετάφραση',
    TranslateAll             : 'Μετάφραση Όλων',
    Yes                      : 'Ναι',
    No                       : 'Όχι',
    Ok                       : 'Οκ',
    Accept                   : 'Αποδοχή',
    Next                     : 'Επόμενο',
    Previous                 : 'Προηγούμενο',
    Back                     : 'Πίσω',
    Dismiss                  : 'Καθαρισμός',
    View                     : 'Προβολή',
    Add                      : 'Προσθήκη',
    Remove                   : 'Αφαίρεση',
    Clear                    : 'Καθαρισμός',
    Reset                    : 'Επαναφορά',
    End                      : 'Τέλος',
    Finish                   : '@:Common.Button.End',
    Preview                  : 'Προεπισκόπηση',
    Renew                    : 'Ανανέωση',
    Copy                     : 'Αντιγραφή',
    Edit                     : 'Επεξεργασία',
    Move                     : 'Μεταφορά',
    MoveSelected             : 'Μεταφορά Επιλεγμένων',
    MoveAll                  : 'Μεταφορά Όλων',
    Reports                  : 'Αναφορές',
    Download                 : 'Download',
    Print                    : 'Εκτύπωση',
    PrintOrder               : 'Εκτύπωση Δελτίου Σύνοψης Παραγγελίας',
    PrintOrderMarketing      : 'Εκτύπωση Marketing',
    PrintPreparation         : 'Εκτύπωση Δελτίου Προετοιμασίας',
    PrintReceipt             : 'Εκτύπωση Απόδειξης',
    PrintReceipts            : 'Εκτύπωση Αποδείξεων',
    PrintInvoice             : 'Εκτύπωση Τιμολογίου',
    PrintFiscalDoc           : 'Εκτύπωση Παραστατικού',
    PrintFnb                 : 'Εκτύπωση Δελτίου Παραγγελίας',
    ViewDocument             : 'Προβολή Παραστατικού',
    PrintDocument            : 'Εκτύπωση Παραστατικού',
    RetryDocument            : 'Διαβίβαση Παραστατικού',
    EmailDocument            : 'Αποστολή Παραστατικού με Email',
    CancelReceipt            : 'Ακύρωση Απόδειξης',
    CancelFiscalDoc          : 'Ακύρωση Παραστατικού',
    ConvertReceipt           : 'Μετατροπή σε Τιμολόγιο',
    CancelInvoice            : 'Ακύρωση Τιμολογίου',
    CancelFnb                : 'Ακύρωση Δελτίου Παραγγελίας',
    UpdatePaymentMethods     : 'Ενημέρωση Τρόπων Πληρωμής',
    ManageDocuments          : 'Διαχείριση Παραστατικών',
    ManageDocument           : 'Διαχείριση Παραστατικού',
    ManageReceipt            : 'Διαχείριση Απόδειξης',
    ManageInvoice            : 'Διαχείριση Τιμολογίου',
    ManageFnb                : 'Διαχείριση Δελτίου Παραγγελίας',
    EmailReceipt             : 'Αποστολή Απόδειξης με Email',
    EmailInvoice             : 'Αποστολή Τιμολογίου με Email',
    EmailFnb                 : 'Αποστολή Δελτίου Παραγγελίας με Email',
    ViewReceipt              : 'Προβολή Απόδειξης',
    ViewInvoice              : 'Προβολή Τιμολογίου',
    ViewFiscalDoc            : 'Προβολή Παραστατικού',
    ViewFnb                  : 'Προβολή Δελτίου Παραγγελίας',
    IssueDocument            : 'Έκδοση Παραστατικού',
    IssueReceipt             : 'Έκδοση Απόδειξης',
    IssueReceipts            : 'Έκδοση Αποδείξεων',
    IssueReceiptSale         : 'Έκδοση Απόδειξης Λιανικής Πώλησης',
    IssueReceiptService      : 'Έκδοση Απόδειξης Παροχής Υπηρεσιών',
    IssueReceiptCollection   : 'Έκδοση Απόδειξης Είσπραξης',
    IssueReceiptSelfSupply   : 'Έκδοση Στοιχείου Αυτοπαράδοσης',
    IssueReceiptSelfUse      : 'Έκδοση Στοιχείου Ιδιοχρησιμοποίησης',
    IssueInvoice             : 'Έκδοση Τιμολογίου',
    IssueInvoiceSale         : 'Έκδοση Τιμολογίου Πώλησης',
    IssueInvoiceService      : 'Έκδοση Τιμολογίου Παροχής Υπηρεσιών',
    IssueFnb                 : 'Έκδοση Δελτίου Παραγγελίας',
    ExternalReceipt          : 'Εξωτερική Απόδειξη',
    Payment                  : 'Πληρωμή',
    TransactionAdd           : 'Προσθήκη Συναλλαγής',
    TransactionSplitPersonAdd: 'Προσθήκη Συναλλαγής ανά Άτομο',
    Left                     : 'Αριστερά',
    Right                    : 'Δεξιά',
    Toggle                   : {
      Active    : 'Ενεργό',
      ActiveF   : 'Ενεργή',
      ActiveM   : 'Ενεργός',
      Inactive  : 'Ανενεργό',
      InactiveF : 'Ανενεργή',
      InactiveM : 'Ανενεργός',
      Horizontal: 'Οριζόντια',
      Vertical  : 'Κάθετα',
      Locked    : 'Κλειδωμένο',
      Unlocked  : 'Ξεκλείδωτο',
      Visible   : 'Φανερό',
      Hidden    : 'Κρυφό'
    },
    Import: {
      Icon : 'file_upload',
      Title: 'Εισαγωγή'
    },
    Export: {
      Icon : 'file_download',
      Title: 'Εξαγωγή'
    }
  },

  Misc: {
    Desc          : 'Περιγραφή',
    Printer       : 'Εκτυπωτές | Εκτυπωτής | Εκτυπωτές',
    Total         : 'Σύνολο',
    Change        : 'Ρέστα',
    Payment       : 'Πληρωμή',
    Subtotal      : 'Υποσύνολο',
    PricePerPerson: 'Κόστος / Άτομο',
    Person        : 'Άτομο',
    Name          : 'Όνομα',
    Discount      : 'Έκπτωση',
    Discounts     : 'Εκπτώσεις',
    ExtraCharges  : 'Χρέωση',
    Balance       : 'Υπόλοιπο',
    Tip           : 'Tip',
    Details       : 'Στοιχεία',
    Default       : 'Προεπιλογή',
    Quantity      : 'Ποσότητα',
    Status        : 'Κατάσταση',
    Welcome       : 'Καλώς Ήρθατε',
    With          : 'Με',
    Without       : 'Χωρίς',
    Type          : 'Τύπος',
    Vat           : 'ΦΠΑ',
    All           : 'Όλα',
    And           : 'και',
    In            : 'σε',
    RequiredField : '* Υποδηλώνει υποχρεωτικό πεδίο',
    UsersOnline   : 'Χρήστες Online',
    TestOrder     : 'ΔΟΚΙΜΑΣΤΙΚΗ ΠΑΡΑΓΓΕΛΙΑ',
    Notification  : {
      ImportPlatformInProgress: 'Παρακαλώ περιμένετε μέχρι να<br>ολοκληρωθεί η εισαγωγή του καταλόγου',
      ImportEFoodSuccess      : 'Η εισαγωγή απο το E-Food ξεκίνησε με επιτυχία',
      ImportFoodySuccess      : 'Η εισαγωγή απο το Foody ξεκίνησε με επιτυχία',
      ImportBoxSuccess        : 'Η εισαγωγή απο το Box ξεκίνησε με επιτυχία',
      ImportWoltSuccess       : 'Η εισαγωγή απο το Wolt ξεκίνησε με επιτυχία',
      ImportFagiSuccess       : 'Η εισαγωγή απο το Fagi ξεκίνησε με επιτυχία',
      ImportGetFoodSuccess    : 'Η εισαγωγή απο το Get Food ξεκίνησε με επιτυχία',
      FieldError              : 'Ελέγξτε ότι συμπληρώσατε όλα τα στοιχεία σωστά!',
      GenericError            : 'Υπήρξε κάποιο πρόβλημα. Προσπαθήστε ξανά.',
      DeliveryPaymentComplete : {
        Success: 'Η πληρωμή της παραγγελίας ολοκληρώθηκε με επιτυχία',
        Error  : 'Υπήρξε πρόβλημα κατά ολοκλήρωση πληρωμής της παραγγελίας. Παρακαλώ δοκιμάστε ξανά!'
      },
      DeliveryPaymentConvert: {
        Success: 'Ο τρόπος πληρωμής της συναλλαγής άλλαξε με επιτυχία',
        Error  : 'Υπήρξε πρόβλημα κατά την αλλαγή του τρόπου πληρωμής της συναλλαγής. Παρακαλώ δοκιμάστε ξανά!'
      },
      IssueReceipt: {
        Success: 'Το παραστατικό έχει εκδοθεί επιτυχώς',
        Error  : 'Υπήρξε πρόβλημα κατά την έκδοσή του παραστατικού. Παρακαλώ δοκιμάστε ξανά!',
        Warning: {
          Title: 'Μη έκδοση παραστατικού',
          Order: '{receiptType}<br><strong>Παραγγελία:</strong> {orderCode}<br><strong>Σύνολο:</strong> {amount}',
          Table: '{receiptType}<br><strong>Τραπέζι:</strong> {table}<br><strong>Παραγγελία:</strong> {tableOrder}<br><strong>Σύνολο:</strong> {amount}'
        }
      },
      ConvertReceipt: {
        Success: 'Η απόδειξη έχει μετατραπεί σε τιμολόγιο επιτυχώς',
        Error  : 'Υπήρξε πρόβλημα κατά την μετατροπή της απόδειξης σε τιμολόγιο. Παρακαλώ δοκιμάστε ξανά!'
      },
      CancelReceipt: {
        Success: 'Το παραστατικό έχει ακυρωθεί επιτυχώς',
        Error  : 'Υπήρξε πρόβλημα κατά την ακύρωση του παραστατικού. Παρακαλώ δοκιμάστε ξανά!'
      },
      RetryReceipt: {
        Success: 'Το παραστατικό έχει σταλεί προς διαβίβαση',
        Error  : 'Υπήρξε πρόβλημα κατά την αποστολή του παραστατικού προς διαβίβαση. Παρακαλώ δοκιμάστε ξανά!'
      },
      PrintReceipt: {
        Success: 'Το παραστατικό έχει σταλεί για εκτύπωση',
        Error  : 'Υπήρξε πρόβλημα κατά την εκτύπωση του παραστατικού. Παρακαλώ δοκιμάστε ξανά!'
      },
      EmailReceipt: {
        Success: 'Το παραστατικό έχει σταλεί με Email επιτυχώς',
        Error  : 'Υπήρξε πρόβλημα κατά την αποστολή του παραστατικού με Email. Παρακαλώ δοκιμάστε ξανά!'
      },
      EmailReport: {
        Success: 'Η αναφορά έχει σταλεί με Email επιτυχώς',
        Error  : 'Υπήρξε πρόβλημα κατά την αποστολή της αναφοράς με Email. Παρακαλώ δοκιμάστε ξανά!'
      },
      TaxesOrphaned: {
        Both    : 'Υπάρχουν <strong>{categories} κατηγορίες</strong> και <strong>{products} προϊόντα</strong> που δεν έχει εφαρμοστεί κατηγορία ΦΠΑ!',
        Category: 'Υπάρχουν <strong>{categories} κατηγορίες</strong> που δεν έχει εφαρμοστεί κατηγορία ΦΠΑ! | Υπάρχει <strong>{categories} κατηγορία</strong> που δεν έχει εφαρμοστεί κατηγορία ΦΠΑ! | Υπάρχουν <strong>{categories} κατηγορίες</strong> που δεν έχει εφαρμοστεί κατηγορία ΦΠΑ!',
        Product : 'Υπάρχουν <strong>{products} προϊόντα</strong> που δεν έχει εφαρμοστεί κατηγορία ΦΠΑ! | Υπάρχει <strong>{products} προϊόν</strong> που δεν έχει εφαρμοστεί κατηγορία ΦΠΑ! | Υπάρχουν <strong>{products} προϊόντα</strong> που δεν έχει εφαρμοστεί κατηγορία ΦΠΑ!'
      }
    },
    WaitProgress: {
      Title: 'Παρακαλώ περιμένετε'
    },
    Retry         : 'Παρακαλώ προσπαθήστε ξανά.',
    Attention     : 'Προσοχή',
    Copy          : 'Αντιγράφηκε επιτυχώς',
    Exit          : 'Έξοδος',
    ExitApp       : 'Έξοδος από την εφαρμογή',
    DeviceTerminal: {
      Section : 'Τερματικό Eft/Pos',
      Title   : 'Τερματικό Συσκευής',
      SubTitle: 'Ορίστε τερματικό συσκευής'
    },
    LogoutDialog: {
      Title  : 'Αποσύνδεση',
      Body   : 'Θέλετε να αποσυνδεθείτε;',
      Warning: 'Το Online κατάστημα θα σταματήσει να δέχεται παραγγελίες αν δεν υπάρχει άλλος σταθμός εργασίας ενεργός.'
    },
    ExitAppDialog: {
      Title  : '@:Common.Misc.Exit',
      Body   : 'Θέλετε να κάνετε έξοδο από την εφαρμογή;',
      Warning: '@:Common.Misc.LogoutDialog.Warning'
    }
  },

  Table: {
    Text: {
      LoadingText  : '',
      NoDataText   : 'Δεν υπάρχουν εγγραφές',
      NoResultsText: 'Δεν υπάρχουν αποτελέσματα'
    },
    Pagination: {
      From: 'από',
      To  : 'έως'
    },

    Result: {
      NoDataText      : 'Δεν υπάρχουν διαθέσιμες εγγραφές',
      NoResultsText   : 'Δεν βρέθηκαν εγγραφές',
      RowsPerPageItems: [10, 15, 25],
      RowsPerPageText : 'Εγγραφές ανά σελίδα'
    }
  },

  Search: {
    Label      : 'Αναζήτηση',
    Icon       : 'search',
    Description: 'Αποτελέσματα Αναζήτησης'
  },

  CallsQueue: {
    Toolbar: {
      Title : 'Τηλ. Κλήσεις',
      Button: {
        Title: '@:Common.Button.View όλων'
      }
    },
    ListView: {
      Title     : 'Κλήσεις | Κλήση | Κλήσεις',
      NoCall    : 'Δεν Υπάρχουν',
      InProgress: {
        Title: 'Κλήσεις σε Εξέλιξη | Κλήση σε Εξέλιξη | Κλήσεις σε Εξέλιξη',
        Icon : 'phone_in_talk'
      },
      OnHold: {
        Title: 'Κλήσεις σε Αναμονή | Κλήση σε Αναμονή | Κλήσεις σε Αναμονή',
        Icon : 'phone_paused'
      },
      Missed: {
        Title: 'Αναπάντητες Κλήσεις | Αναπάντητη Κλήση | Αναπάντητες Κλήσεις',
        Icon : 'phone_missed'
      },
      Common: {
        PotentialCustomer: 'Πιθανοί Πελάτες',
        UnknownCustomer  : 'Άγνωστος Πελάτης',
        HiddenCallerID   : 'Απόκρυψη Αριθμού',
        NewOrder         : 'Νέα Παραγγελία',
        NewReservation   : 'Νέα Κράτηση',
        CustomerTab      : 'Καρτέλα Πελάτη'
      },
      Button: {
        Dismiss: {
          Title: '@:Common.Button.Dismiss Όλων',
          Icon : 'delete_forever',
          Color: 'red'
        },
        DismissAndNewOrder: {
          Title: '@:Common.Button.Dismiss & Νέα Παραγγελία',
          Icon : 'add_shopping_cart'
        },
        DismissAndNewReservation: {
          Title: '@:Common.Button.Dismiss & Νέα Κράτηση',
          Icon : 'mdi mdi-book-open-variant'
        }
      }
    }
  },

  ConfirmDialog: {
    Title: 'Είστε Σίγουροι;'
  },

  NumPadDialog: {
    Title: 'Εισάγετε Τιμή'
  },

  EmailSelectDialog: {
    Toolbar: {
      Title   : 'Επιλογή Email',
      Subtitle: 'Εισάγετε ή Επιλέξτε Email',
      Icon    : 'mdi-email-search-outline',
      Color   : 'blue'
    }
  },

  OnlineStatus: {
    Title: {
      Open  : 'Ανοιχτά',
      Closed: 'Κλειστά'
    }
  },

  OrdersQueue: {
    Button: {
      Title: '@:Common.Button.View όλων'
    },
    ListView: {
      Title: {
        ToAccept  : 'προς Αποδοχή',
        ToComplete: 'προς Ολοκλήρωση'
      },
      ListItem: {
        Visitor  : 'Επισκέπτης',
        Telephone: 'Τηλ:'
      }
    },
    Notification: {
      Title  : 'Εκκρεμής Παραγγελία',
      Order  : 'παραγγελίας',
      Content: {
        Delay : 'Έχετε καθυστερήσει',
        Doing : 'να κάνετε',
        Cancel: 'ή ΑΚΥΡΩΣΗ την εκκρεμής παραγγελία',
        Order : 'την παραγγελία'
      },
      Button: {
        Close : 'Κλείσιμο χωρίς υπενθύμιση',
        Remind: 'Υπενθύμιση σε 5"',
        View  : 'Προβολή παραγγελίας',
        Cancel: '@:Common.Button.Cancel @:Common.OrdersQueue.Notification.Order'
      }
    },
    AcceptOrder: {
      Title  : 'Αποδοχή Εκκρεμούς Παραγγελίας',
      Content: {
        Payment: 'Οι εκκρεμείς παραγγελίες δεν έχουν ακόμη επιβεβαιωμένη πληρωμή.',
        Choose : 'Επιλέξτε αν θέλετε να',
        Accept : 'αποδεχτείτε',
        Edit   : 'επεξεργαστείτε',
        Order  : 'αυτή την εκκρεμής παραγγελία ή όχι.'
      }
    }
  },

  SelectDateRangeDialog: {
    Toolbar: {
      Title   : 'Επιλογή Περιόδου',
      Subtitle: 'Επιλέξτε ημερομηνία από - έως',
      Color   : 'primary',
      Icon    : 'date_range'
    },
    Field: {
      Staff: {
        Label: 'Χρήστης',
        Hint : 'Επιλέξτε χρήστη',
        All  : 'Όλοι οι χρήστες',
        Icon : 'supervisor_account'
      },
      Guid: {
        Label: 'Θέση Εργασίας',
        Hint : 'Επιλέξτε Θέση Εργασίας',
        All  : 'Όλες οι θέσεις εργασίας',
        Icon : 'mdi-desktop-classic'
      }
    }
  },

  FiscalDoc: [
    {
      Id    : FiscalDocTypeCodeEnum.GREEK_SALE_INVOICE,
      Code  : FiscalDocTypeEnum.INVOICE,
      Name  : 'Τιμολόγιο Πώλησης',
      Avatar: {
        Color: 'blue',
        Icon : 'mdi-receipt-text'
      }
    },
    {
      Id    : FiscalDocTypeCodeEnum.GREEK_INVOICE_CREDIT_1,
      Code  : FiscalDocTypeEnum.INVOICE_CREDIT,
      Name  : 'Πιστωτικό Τιμολόγιο / Συσχετιζόμενο',
      Avatar: {
        Color: 'red',
        Icon : 'mdi-receipt-text-remove'
      }
    },
    {
      Id    : FiscalDocTypeCodeEnum.GREEK_INVOICE_CREDIT_2,
      Code  : FiscalDocTypeEnum.INVOICE_CREDIT_NO,
      Name  : 'Πιστωτικό Τιμολόγιο / Μη Συσχετιζόμενο',
      Avatar: {
        Color: 'red',
        Icon : 'mdi-receipt-text-remove'
      }
    },
    {
      Id    : FiscalDocTypeCodeEnum.GREEK_SALE_RECEIPT,
      Code  : FiscalDocTypeEnum.RECEIPT,
      Name  : 'Απόδειξη Λιανικής Πώλησης',
      Avatar: {
        Color: 'green',
        Icon : 'mdi-receipt-text'
      }
    },
    {
      Id    : FiscalDocTypeCodeEnum.GREEK_SERVICE_RECEIPT,
      Code  : FiscalDocTypeEnum.SERVICE_RECEIPT,
      Name  : 'Απόδειξη Παροχής Υπηρεσιών',
      Avatar: {
        Color: 'green',
        Icon : 'mdi-receipt-text'
      }
    },
    {
      Id    : FiscalDocTypeCodeEnum.GREEK_RECEIPT_CREDIT,
      Code  : FiscalDocTypeEnum.RECEIPT_CREDIT,
      Name  : 'Πιστωτικό Στοιχ. Λιανικής',
      Avatar: {
        Color: 'red',
        Icon : 'mdi-receipt-text-remove'
      }
    },
    {
      Id    : FiscalDocTypeCodeEnum.GREEK_DOCUMENT_ORDER,
      Code  : FiscalDocTypeEnum.FNB,
      Name  : 'Δελτίο Παραγγελίας Εστίασης',
      Avatar: {
        Color: 'blue-grey',
        Icon : 'mdi-receipt-text'
      }
    },
    {
      Id    : FiscalDocTypeCodeEnum.GREEK_DOCUMENT_ORDER_CANCEL,
      Code  : FiscalDocTypeEnum.FNB_CANCEL,
      Name  : 'Δελτίο Παραγγελίας Ακύρωσης',
      Avatar: {
        Color: 'blue-grey',
        Icon : 'mdi-receipt-text'
      }
    },
    {
      Id    : FiscalDocTypeCodeEnum.GREEK_DOCUMENT_ORDER_RETURN,
      Code  : FiscalDocTypeEnum.FNB_RETURN,
      Name  : 'Δελτίο Παραγγελίας Επιστροφής',
      Avatar: {
        Color: 'blue-grey',
        Icon : 'mdi-receipt-text'
      }
    },
    {
      Id    : FiscalDocTypeCodeEnum.GREEK_RECEIPT_SELF_SUPPLY,
      Code  : FiscalDocTypeEnum.RECEIPT_SELF_SUPPLY,
      Name  : 'Στοιχείο Αυτοπαράδοσης (πώληση ειδών)',
      Avatar: {
        Color: 'blue-grey',
        Icon : 'mdi-receipt-text'
      }
    },
    {
      Id    : FiscalDocTypeCodeEnum.GREEK_RECEIPT_SELF_SUPPLY_CREDIT,
      Code  : FiscalDocTypeEnum.RECEIPT_SELF_SUPPLY_CREDIT,
      Name  : 'Πιστωτικό Στοιχείο Αυτοπαράδοσης (πώληση ειδών)',
      Avatar: {
        Color: 'blue-grey',
        Icon : 'mdi-receipt-text'
      }
    },
    {
      Id    : FiscalDocTypeCodeEnum.GREEK_RECEIPT_SELF_USE,
      Code  : FiscalDocTypeEnum.RECEIPT_SELF_USE,
      Name  : 'Στοιχείο Ιδιοχρησιμοποίησης (παροχή υπηρεσιών)',
      Avatar: {
        Color: 'blue-grey',
        Icon : 'mdi-receipt-text'
      }
    },
    {
      Id    : FiscalDocTypeCodeEnum.GREEK_RECEIPT_SELF_USE_CREDIT,
      Code  : FiscalDocTypeEnum.RECEIPT_SELF_USE_CREDIT,
      Name  : 'Πιστωτικό Στοιχείο Ιδιοχρησιμοποίησης (παροχή υπηρεσιών)',
      Avatar: {
        Color: 'blue-grey',
        Icon : 'mdi-receipt-text'
      }
    }
  ],

  Map: {
    Title    : 'Χάρτης',
    Satellite: 'Δορυφόρος'
  },

  ColorPicker: {
    Error: {
      InvalidColor: 'Δεν είναι έγκυρος κωδικός χρώματος!'
    }
  },

  Error: {
    Mandatory: 'Το πεδίο είναι υποχρεωτικό',
    Required : 'Το πεδίο είναι υποχρεωτικό',
    Generic  : 'Υπήρξε κάποιο πρόβλημα! Παρακαλώ δοκιμάστε ξανά αργότερα.',
    Offline  : {
      Icon    : 'mdi-wifi-off',
      Title   : 'Χωρίς σύνδεση στο Internet',
      Subtitle: 'Η σύνδεσή σας στο Internet δεν είναι προς το παρόν διαθέσιμη, ελέγξτε ή δοκιμάστε ξανά.',
      Button  : 'Δοκιμάστε Ξανά',
      Electron: {
        Title       : 'Εκτύπωση Παραγγελιών Ανενεργή!',
        WorkStations: 'Offline Θέσεις εργασίας'
      }
    }
  }
}
